import { gql } from "graphql-tag";

export const GET_QUEUES = gql`
  query GetQueues($pagination: PaginationInput, $filter: QueueFilterInput) {
    queues(pagination: $pagination, filter: $filter) {
      data {
        id
        name
        description
        accountId
        emailSignature
        notificationEmail
        isDefault
        emailAlias
        queueUsers {
          id
          userId
          user {
            id
            firstName
            lastName
            email
          }
        }
        queueLocations {
          id
          locationId
          location {
            id
            name
          }
        }
        problemCategoryQueues {
          id
          problemCategoryId
          problemCategory {
            id
            name
          }
        }
        queueEmailTemplates {
          id
          type
          content
        }
        createdAt
        updatedAt
      }
      meta {
        page
        limit
        total
        totalPages
        hasNext
        hasPrev
      }
    }
  }
`;

export const GET_QUEUE = gql`
  query GetQueue($id: ID!) {
    queue(id: $id) {
      id
      name
      description
      accountId
      emailSignature
      notificationEmail
      isDefault
      emailAlias
      queueUsers {
        id
        userId
        user {
          id
          firstName
          lastName
          email
          role
        }
      }
      queueLocations {
        id
        locationId
        location {
          id
          name
        }
      }
      problemCategoryQueues {
        id
        problemCategoryId
        problemCategory {
          id
          name
        }
      }
      queueEmailTemplates {
        id
        type
        content
      }
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_QUEUE = gql`
  mutation CreateQueue($input: CreateQueueInput!) {
    createQueue(input: $input) {
      id
      name
      description
      accountId
      emailSignature
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_QUEUE = gql`
  mutation UpdateQueue($id: ID!, $input: UpdateQueueInput!) {
    updateQueue(id: $id, input: $input) {
      id
      name
      description
      accountId
      emailSignature
      queueUsers {
        id
        userId
        user {
          id
          firstName
          lastName
          email
        }
      }
      queueEmailTemplates {
        id
        type
        content
      }
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_QUEUE = gql`
  mutation DeleteQueue($id: ID!) {
    deleteQueue(id: $id)
  }
`;
